import DashboardInfo from "components/DashboardInfo";

export default function myProgress() {
  return (
    <div className="flex mx-auto justify-center sm:max-w-[70vw] lg:max-w-[60vw] gap-5 p-5 pt-8 pb-14">
      <DashboardInfo />
    </div>
  );
}
